export enum ContentTypes {
  Website = 'website',
  TournamentSeriesStats = 'tournament_series_stats',
  TournamentSeriesLeaderboard = 'tournament_series_leaderboard',
  TournamentSeries = 'tournament_series',
  Top = 'top',
  TilesGrid = 'tiles_grid',
  Terms = 'terms',
  Tabs = 'tabs',
  SiteHeader = 'site_header',
  SiteFooter = 'site_footer',
  SideTwitter = 'side_twitter',
  SideRelatedContent = 'side_related_content',
  SideCTA = 'side_cta',
  Side = 'side',
  SEO = 'seo',
  PaymentVendors = 'payment_vendors',
  Panel = 'panel',
  Page = 'page',
  Meta = 'meta',
  Menu = 'menu',
  MediaGrid = 'media_grid',
  Language = 'language',
  License = 'license',
  Highlight = 'highlight',
  Glossary = 'glossary',
  Global = 'global',
  FAQ = 'faq',
  DetailsGrid = 'details_grid',
  ContentCard = 'content_card',
  ContentArea = 'content_area',
  CategoryHighlight = 'category_highlight',
  CTAGrid = 'cta_grid',
  Brand = 'brand',
  Accordion = 'accordion'
}
